interface Birthday {
  day: number;
  month: string;
  year: number;
}

const birthdayToDate = (birthday: Birthday) => {
  return new Date(Date.parse(`${birthday.month} ${birthday.day}, ${birthday.year}`));
};

function getAge(birthday: Birthday) {
  const birthdayDate = birthdayToDate(birthday);
  const ageDiff = Date.now() - birthdayDate.getTime();
  const ageDate = new Date(ageDiff);

  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export { birthdayToDate, getAge };
export default Birthday;
